module.exports = __webpack_public_path__ + "static/media/Yopen-Branco.fec04f59.png";